export const Image = {
  logo: '/imgs/logo.svg',
};

export const Icon = {
  menuIcon: '/icons/menu-icon.svg',
};
